import { createSlice } from '@reduxjs/toolkit';
import { clearTokens, setTokens } from 'utils/cookies';
import { clearConfirmRefreshTimer } from 'services/sessionTimerService';
import { SESSION_STATUS } from './sessionConstants';
import { purgeUserPersistedStorage } from './persistence';

export { SESSION_STATUS } from './sessionConstants';

export const sessionSlice = createSlice({
    name: 'session',
    initialState: {
        status: SESSION_STATUS.BOOTSTRAPPING,
    },
    reducers: {
        sessionBootstrapped: (state, action) => {
            state.status = action.payload
                ? SESSION_STATUS.AUTHENTICATED
                : SESSION_STATUS.ANONYMOUS;
        },
        sessionAuthenticated: (state) => {
            state.status = SESSION_STATUS.AUTHENTICATED;
        },
        sessionEnded: (state) => {
            state.status = SESSION_STATUS.ANONYMOUS;
        },
    },
});

export const {
    sessionBootstrapped,
    sessionAuthenticated,
    sessionEnded,
} = sessionSlice.actions;

export const establishSession = ({ accessToken, refreshToken }) => (dispatch) => {
    clearConfirmRefreshTimer();
    clearTokens();
    purgeUserPersistedStorage();
    dispatch(sessionEnded());
    setTokens(accessToken, refreshToken);
    dispatch(sessionAuthenticated());
};

export const endSession = () => (dispatch) => {
    clearConfirmRefreshTimer();
    clearTokens();
    purgeUserPersistedStorage();
    dispatch(sessionEnded());
};

export default sessionSlice.reducer;
